<template>
  <div>
    <div v-for="collection in collections" :key="collection.title">
      <h2 :id="collection.title">{{collection.title}}
        <br/><a style="font-size: small" href="#top">Go Back To Top</a>
      </h2>
      <div style="margin-left: 10px">
        <Collection v-for="(song,index) in collection.items" :key="`song_${index}`" :value="song" @search-wikia="$emit('search-wikia', $event)"/>
      </div>
    </div>
  </div>
</template>

<script>
  import Collection from "./Collection";

  export default {
    name: "Collections",
    components: {Collection},
    data: function () {
      return {}
    },
    props: {
      collections: {type: Array},
    },
  }
</script>

<style scoped>

</style>